import type { ButtonHTMLAttributes } from 'react';
import { Link, type LinkProps } from 'react-router-dom';

type DefaultProps = Readonly<
    ButtonHTMLAttributes<HTMLButtonElement> & {
        isPrimary?: boolean;
    }
>;

const DEFAULT_CLASSNAME =
    'flex justify-center text-small font-medium leading-[1.5rem] rounded-full border border-solid border-light-gray disabled:opacity-50';

export function Button({ isPrimary = true, className, children, ...props }: DefaultProps) {
    return (
        <button
            className={[
                `${DEFAULT_CLASSNAME} py-2 px-4`,
                isPrimary ? 'bg-primary text-dark-gray' : 'bg-white text-gray',
                className,
            ]
                .filter(Boolean)
                .join(' ')}
            {...props}
        >
            {children}
        </button>
    );
}

export function ButtonLarge({ isPrimary = true, className, children, ...props }: DefaultProps) {
    return (
        <Button
            isPrimary={isPrimary}
            className={[`${DEFAULT_CLASSNAME} px-16 py-2`, className].join(' ')}
            {...props}
        >
            {children}
        </Button>
    );
}

type AddButtonProps = Readonly<
    Omit<DefaultProps, 'children'> & {
        icon: string;
        label?: string;
    }
>;

export function IconButton({ label, icon, ...props }: AddButtonProps) {
    return (
        <Button {...props}>
            <img src={icon} className={`w-4.5${label === undefined ? '' : ' mr-1'}`} alt={label} />
            {label}
        </Button>
    );
}

type ButtonLinkProps = Readonly<
    LinkProps & {
        to: string;
        isPrimary?: boolean;
    }
>;

export function ButtonLink({
    to,
    isPrimary = true,
    className,
    children,
    ...props
}: ButtonLinkProps) {
    return (
        <Link
            className={[
                `${DEFAULT_CLASSNAME} py-2 px-4`,
                isPrimary ? 'bg-primary text-dark-gray' : 'bg-white text-gray',
                className,
            ].join(' ')}
            {...props}
            to={to}
        >
            {children}
        </Link>
    );
}
